import { HelpCircle } from 'lucide-react';

import NavItem from './NavItem';

// The "Help" rail link: straight to the in-app help centre, where live chat sits beside
// the search and the assistant.
const HelpLink = () => <NavItem to="/help" label="Help" icon={HelpCircle} testId="nav-link-help" />;

export default HelpLink;
